import React, { useState } from 'react';

import { H3, H4 } from '../../primitives/appTitle';
import AppSection from '../../primitives/appSection';
import PatternSvg from '../../components/svg/patternSvg';
import { FrontCommonMessages } from '../../appCommonTranslations';
import { ShText } from '@shoootin/translations';
import { GalleryModal2 } from '../../components/gallery/galleryModal';
import SliderOfferWrapper from './sliderOfferWrapper';
import { ProfessionShootingType } from '../../appConstants';
import { MetierPageOffersPhoto } from './metierPageOffers';
import { getProfessionMessage } from '../../appMessageDefinitions';
import { AppGatsbyImageFluid } from '../../primitives/appImage';
import AppSlider from '../../primitives/appSlider';

const MetierPhotoContent = ({
  profession,
  photos,
}: {
  profession: ProfessionShootingType;
  photos: AppGatsbyImageFluid[];
}) => {
  // const [initialGalleryPhoto, setInitialGalleryPhoto] = useState<
  //   GalleryPhoto
  // >();

  const [open, setOpen] = useState<boolean>(false);
  return (
    <div className="metier-content">
      <div className="metier-gallery">
        <AppSlider
          className="gallery-slider"
          images={photos}
          onImageClick={(index) => setOpen(true)}
        />
        {/* <ImageSlider
          slides={photos.map((p) => ({ src: p.mediumSrc }))}
          className="gallery-slider"
          showNav
          showPagination
          onSlideClick={(_, index) => setInitialGalleryPhoto(photos[index])}
          isSlideLazy={(slide, slideIndex) => slideIndex > 0}
        /> */}
        {open && (
          <GalleryModal2
            content={{
              label: getProfessionMessage(profession, 'title'),
              photoGallery: photos,
            }}
            onClose={
              () => {
                setOpen(false);
              } // setInitialGalleryPhoto(undefined)
            }
          />
        )}
        {/* <GalleryModal
          content={
            initialGalleryPhoto
              ? {
                  label: getProfessionMessage(profession, 'title'),
                  photoGallery: photos,
                  initialPhoto: initialGalleryPhoto,
                }
              : undefined
          }
          onClose={() => setInitialGalleryPhoto(undefined)}
        /> */}
        <PatternSvg />
      </div>
      <div className="metier-text">
        <H3>
          <ShText message={FrontCommonMessages.professionPhotoSectionTitle} />
        </H3>
        <p>
          <ShText
            message={getProfessionMessage(profession, 'photoDescription')}
          />
        </p>
        <div
          className="link"
          // onClick={() => setInitialGalleryPhoto(first(photos))}
        >
          <ShText message={FrontCommonMessages.seeGallery} />
        </div>
      </div>
    </div>
  );
};

const MetierPhotoOffers = ({
  profession,
  offers,
}: {
  profession: ProfessionShootingType;
  offers: MetierPageOffersPhoto;
}) => {
  return (
    <>
      <div className="metier-slider">
        <H4>
          <ShText message={getProfessionMessage(profession, 'photoOffers')} />
          <span className="metier-pattern" data-parallax="-0.1">
            <PatternSvg />
          </span>
        </H4>
        <SliderOfferWrapper
          offers={offers.photoOffers}
          currency={offers.currency}
          shootingType={profession}
        />
      </div>

      {/* <div className="metier-options">
            <H4>Options supplémentaires</H4>

            <Options options={{} as any} />
            </div> */}
    </>
  );
};

const MetierPhotoSection = ({
  profession,
  photos,
  offers,
}: {
  profession: ProfessionShootingType;
  photos: AppGatsbyImageFluid[];
  offers?: MetierPageOffersPhoto;
}) => {
  return (
    <AppSection className="metier-section photo left darker" id="offers">
      <MetierPhotoContent profession={profession} photos={photos} />
      {offers && <MetierPhotoOffers profession={profession} offers={offers} />}
    </AppSection>
  );
};

export default MetierPhotoSection;
